import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe864564"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 mt-4 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Statlig operatör:"),
    /*#__PURE__*/_createTextVNode(" České dráhy (ČD)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Privata operatörer:"),
    /*#__PURE__*/_createTextVNode(" RegioJet, Leo Express")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Biljetter:"),
    /*#__PURE__*/_createTextVNode(" Köp via appar eller station – ofta billigare i förväg ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resebokning:"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.cd.cz/en/",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "cd.cz"),
    /*#__PURE__*/_createTextVNode(", "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.regiojet.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "regiojet.com")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Språk:"),
    /*#__PURE__*/_createTextVNode(" Tjeckiska talas överallt – men engelska fungerar ofta i turistorter. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Mat och dryck:"),
    /*#__PURE__*/_createTextVNode(" Prisvärt! Missa inte klassiker som svíčková och Pilsner. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Säkerhet:"),
    /*#__PURE__*/_createTextVNode(" Tjeckien är generellt tryggt att resa i, även som ensamresenär. ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Bästa tiden att resa:"),
    /*#__PURE__*/_createTextVNode(" Vår och tidig höst är mest behagliga. ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "list-disc pl-5 space-y-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.interrail.eu/en/plan-your-trip/trip-ideas/czech-republic",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Interrail.eu – Tjeckien")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.cd.cz/en/",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "České dráhy (CD)")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.regiojet.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "RegioJet")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.leoexpress.com",
      target: "_blank",
      class: "text-blue-600 underline"
    }, "Leo Express")
  ])
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import meta from "@/data/meta.json";
import GridCard from "../GridCard.vue";
import ListCard from "../ListCard.vue";
import Breadcrumbs from "@/components/generics/BreadCrumbs.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CzechiaGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).czechiaGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Tjeckien",
      maxHeight: "60vh",
      backgroundImageClass: "background-prague"
    }),
    _createVNode(ContentWrapper, { showBreadcrumbs: true }, {
      default: _withCtx(() => [
        _createVNode(Breadcrumbs),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextBlock, { header: "Upptäck Tjeckien med tåg" }, {
            default: _withCtx(() => [
              _createTextVNode(" Tjeckien bjuder på sagoslott, öl i världsklass och charmiga medeltida städer. Landet är kompakt och tågnätet är väl utbyggt, vilket gör det till en perfekt destination för tågluffare som vill utforska Centraleuropa i ett behagligt tempo. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Att resa med tåg i Tjeckien" }, {
            default: _withCtx(() => [
              _createTextVNode(" Det statliga järnvägsbolaget České dráhy (ČD) driver de flesta tåglinjer, men det finns även privata operatörer som RegioJet och Leo Express. Priserna är låga och du kan boka plats på längre rutter. Interrailkort gäller på de flesta linjer. "),
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(ListCard, {
            title: "Förslag på tågrutter i Tjeckien",
            items: [
					{
						title: 'Klassisk kulturresa',
						description: 'Prag → Kutná Hora → Brno',
						link: '',
					},
					{
						title: 'Slott och spa',
						description: 'Prag → Karlovy Vary → Mariánské Lázně',
						link: '',
					},
					{
						title: 'Öl och historia',
						description: 'Pilsen → České Budějovice → Český Krumlov',
						link: '',
					},
				]
          }),
          _createVNode(GridCard, {
            title: "Destinationer i Tjeckien",
            items: [
					{
						title: 'Prag',
						image: '🌉',
						description:
							'Romantik, arkitektur och billig öl i en av Europas vackraste huvudstäder.',
						link: '/guider/destinationer/tjeckien/prag',
					},
					{
						title: 'Český Krumlov',
						image: '🏰',
						description:
							'En sagolik småstad med slingrande gator, flodliv och medeltida charm.',
						link: '/guider/destinationer/tjeckien/cesky-krumlov',
					},
					{
						title: 'Brno',
						image: '🎭',
						description:
							'Universitetsstad med livlig kultur, kaféer och tjeckisk modernism.',
						link: '/guider/destinationer/tjeckien/brno',
					},
					{
						title: 'Karlovy Vary',
						image: '♨️',
						description:
							'Klassisk kurort med varmvattenkällor, kolonnader och filmfestival.',
						link: '/guider/destinationer/tjeckien/karlovy-vary',
					},
				]
          }, null, 8, ["items"]),
          _createVNode(TextBlock, { header: "Tips för tågluffare i Tjeckien" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Resurser" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})